<template>
    <div>
        <Head :title="`${form.name}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('lakes.index')"
            >
                Озера
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ form.name }}
        </h1>
        <div
            class="rounded-md shadow overflow-hidden"
            :class="{ 'max-w-full': isFormFullWidth, 'max-w-3xl bg-white': !isFormFullWidth }"
        >
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap">
                    <div
                        class="flex flex-wrap mb-8 -mr-6 p-8"
                        :class="{'max-w-3xl rounded-md border-2 border-b-0 bg-white': isFormFullWidth}"
                    >
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Базова ціна за місце"/>
                        <text-input v-model="form.price_per_person" :error="form.errors.price_per_person" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна за одну людину"/>
                        <text-input v-model="form.latitude" :error="form.errors.latitude"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Широта"/>
                        <text-input v-model="form.longitude" :error="form.errors.longitude"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="Довгота"/>
                        <text-input v-model="form.public_liq_pay_key" :error="form.errors.public_liq_pay_key"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="LiqPay public key"/>
                        <text-input v-model="form.private_liq_pay_key" :error="form.errors.private_liq_pay_key"
                                    class="pb-8 pr-6 w-full lg:w-1/2" label="LiqPay private key"/>
                        <textarea-input v-model="form.short_description" :error="form.errors.short_description"
                                        class="pb-8 pr-6 w-full" label="Короткий опис"/>
                        <div class="pb-8 pr-6 w-full">
                            <label class="form-label" for="description">Опис</label>
                            <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                      id="description" class="description"/>
                        </div>
                        <text-input v-model="form.price_depend_on_category" type="checkbox"
                                    :error="form.errors.price_depend_on_category"
                                    class="pb-8 pr-6 w-full admin-input-with-checkbox" label="Ціна залежить від тарифу рибалки"/>
                        <text-input v-model="form.price_depend_on_people_count" type="checkbox"
                                    :error="form.errors.price_depend_on_people_count"
                                    class="pb-8 pr-6 w-full" label="Ціна залежить від кількості людей"/>
                        <text-input v-model="form.price_depend_on_day_of_week" type="checkbox"
                                    :error="form.errors.price_depend_on_day_of_week"
                                    class="pb-8 pr-6 w-full" label="Ціна залежить від дня тижня"/>
                        <text-input v-model="form.is_active" type="checkbox"
                                    :error="form.errors.is_active"
                                    class="pb-8 pr-6 w-full" label="Озеро активне"/>

                        <drag-and-drop
                            v-model="form.image"
                            :error="form.errors.image"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            type="file"
                            accept="image/*"
                            label="Зображення"
                        />
                    </div>
                    <div
                        class="mb-8 -mr-6 p-8"
                        :class="{'max-w-3xl rounded-md border-2 border-b-0 bg-white': isFormFullWidth}"
                    >
                        <div v-if="isPriceDependOnDayOfWeek" class="flex flex-wrap">
                            <text-input v-model="form.monday_price" :error="form.errors.monday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф понедельник"/>
                            <text-input v-model="form.tuesday_price" :error="form.errors.tuesday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф вторник"/>
                            <text-input v-model="form.wednesday_price" :error="form.errors.wednesday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф среда"/>
                            <text-input v-model="form.thursday_price" :error="form.errors.thursday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф четверг"/>
                            <text-input v-model="form.friday_price" :error="form.errors.friday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф пятница"/>
                            <text-input v-model="form.saturday_price" :error="form.errors.saturday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф суббота"/>
                            <text-input v-model="form.sunday_price" :error="form.errors.sunday_price"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Коэф восресенье"/>
                        </div>
                    </div>
                </div>


                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button class="text-red-600 hover:underline" tabindex="-1" type="button"
                            @click="destroy">
                        Видалити озеро
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Оновити озеро
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from "@/Shared/FileInput"
import DragAndDrop from "@/Shared/DragAndDrop"
import checkbox from "@/Shared/Checkbox"
import TextareaInput from "@/Shared/TextareaInput"
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        ckeditor: CKEditor.component
    },
    layout: Layout,
    props: {
        lake: Object,
    },
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                language: 'ru',
                styles: {
                    'height': '500px',
                }
            },
            form: this.$inertia.form({
                _method: 'put',
                name: this.lake.name,
                price: this.lake.price,
                price_per_person: this.lake.price_per_person,
                latitude: this.lake.latitude,
                longitude: this.lake.longitude,
                description: this.lake.description,
                short_description: this.lake.short_description,
                image: null,
                images: null,
                public_liq_pay_key: this.lake.public_liq_pay_key,
                private_liq_pay_key: this.lake.private_liq_pay_key,
                price_depend_on_category: this.lake.price_depend_on_category,
                price_depend_on_people_count: this.lake.price_depend_on_people_count,
                price_depend_on_day_of_week: this.lake.price_depend_on_day_of_week,
                is_active: this.lake.is_active,
                monday_price: this.lake.monday_price ?? 1,
                tuesday_price: this.lake.tuesday_price ?? 1,
                wednesday_price: this.lake.wednesday_price ?? 1,
                thursday_price: this.lake.thursday_price ?? 1,
                friday_price: this.lake.friday_price ?? 1,
                saturday_price: this.lake.saturday_price ?? 1,
                sunday_price: this.lake.sunday_price ?? 1
            }),
        }
    },
    computed: {
        checkbox() {
            return checkbox
        },
        isFormFullWidth() {
            return this.form.price_depend_on_day_of_week
        },
        isPriceDependOnCategory() {
            return this.form.price_depend_on_category
        },
        isPriceDependOnPeopleCount() {
            return this.form.price_depend_on_people_count
        },
        isPriceDependOnDayOfWeek() {
            return this.form.price_depend_on_day_of_week
        }
    },
    methods: {
        update() {
            this.form.post(this.$route('lakes.update', this.lake.id))
        },
        destroy() {
            if (confirm('Ви впевнені що хочете видалити озеро?')) {
                this.$inertia.delete(this.$route('lakes.destroy', this.lake.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this contact?')) {
                this.$inertia.put(`/lakes/${this.lake.id}/restore`)
            }
        },
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 500px;
}
.description {
    width: 100%;
}
</style>
